import { IMenuLabel } from 'src/api/getMenuLabels';

interface IMenuLabelFilterOption {
  id: string;
  label: string;
  display_order: number;
}

export const toMenuLabelFilterOptions = (menuLabels: IMenuLabel[] | undefined): IMenuLabelFilterOption[] =>
  menuLabels?.map(({ menu_label_id, name }, index) => ({ id: menu_label_id, label: name, display_order: index })) ?? [];

/** Keeps the items that have any of the selected labels; with none selected, keeps them all. */
export const filterByMenuLabels = <T extends { menuLabels: IMenuLabel[] }>(
  items: T[],
  selectedMenuLabelIds: string[],
): T[] =>
  selectedMenuLabelIds.length === 0
    ? items
    : items.filter(({ menuLabels }) =>
        menuLabels.some(({ menu_label_id }) => selectedMenuLabelIds.includes(menu_label_id)),
      );
